import { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Search, MessageCircle } from "lucide-react";
import { api, wsUrl } from "@/lib/api";

export function useDmSocket(onEvent) {
  useEffect(() => {
    let ws, retry, closed = false;
    const open = () => {
      ws = new WebSocket(wsUrl("/ws/dm"));
      ws.onmessage = (e) => { try { onEvent(JSON.parse(e.data)); } catch {} };
      ws.onclose = (e) => { if (!closed && e.code !== 4401) retry = setTimeout(open, 3000); };
    };
    open();
    return () => { closed = true; clearTimeout(retry); ws?.close(); };
  }, [onEvent]);
}

export function useUnreadDm() {
  const [n, setN] = useState(0);
  const { pathname } = useLocation();
  const load = useCallback(() => api.get("/dm/unread").then((r) => setN(r.data.unread)).catch(() => {}), []);
  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [pathname, load]);
  const onEvent = useCallback((e) => { if (e.type === "dm") setTimeout(load, 400); }, [load]);
  useDmSocket(onEvent);
  return n;
}

const iconCls = "relative grid h-9 w-9 place-items-center rounded-full text-white/80 transition-colors hover:bg-white/10 hover:text-white";

export function HeaderShortcuts({ dark = false }) {
  const unread = useUnreadDm();
  const cls = dark ? `${iconCls} bg-black/50 backdrop-blur` : iconCls;
  return (
    <>
      <Link to="/buscar" className={cls} aria-label="Buscar perfis" data-testid="header-search-link"><Search size={18} /></Link>
      <Link to="/mensagens" className={cls} aria-label="Mensagens" data-testid="header-messages-link">
        <MessageCircle size={18} />
        {unread > 0 && <span className="absolute -right-0.5 -top-0.5 grid h-4 min-w-4 place-items-center rounded-full bg-rose-500 px-1 text-[10px] font-extrabold text-white" data-testid="header-messages-badge">{unread > 9 ? "9+" : unread}</span>}
      </Link>
    </>
  );
}
